module.exports = __webpack_public_path__ + "img/bee__6.b7790086.svg";